import type { RawParams } from "@uirouter/core";

import { getAvailableWebSource } from "app/components/filters-bar/utils";
import type { WebSource } from "app/components/filters-bar/websource-filter/WebSourceFilter.types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { IDeviceDistributionChartData } from "../../../../../types";

export const adaptSingleMetricDataValue = (data: IDeviceDistributionChartData, webSource: WebSource) => {
    const { mobileWeb, desktop } = data;
    const totalValue = mobileWeb + desktop;

    const singleMetricValue = webSource === "Desktop" ? desktop : mobileWeb;
    const normalizedValue = (singleMetricValue / totalValue) * 100;
    return normalizedValue;
};

const getAvailbleWebSources = (params: RawParams): Array<{ id: string; text: string }> => {
    const currentState = proNavigator.current();
    return getAvailableWebSource(currentState, params);
};
